module.exports = __webpack_public_path__ + "static/media/29EUNOG10.d3c679f7.jpg";